import { render, staticRenderFns } from "./WorksTable.vue?vue&type=template&id=0dd44b53&scoped=true"
import script from "./WorksTable.vue?vue&type=script&lang=js"
export * from "./WorksTable.vue?vue&type=script&lang=js"
import style0 from "./WorksTable.vue?vue&type=style&index=0&id=0dd44b53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd44b53",
  null
  
)

export default component.exports